/* OneMiners cinematic hero — keeps one stable player per miner; never recycles a decoder during handoff. */
(function(){
'use strict';
const CIN_TYPES={av1:'video/mp4; codecs="av01.0.08M.08"',webm:'video/webm; codecs="vp09.00.40.08"',mp4:'video/mp4; codecs="avc1.640029"'};
/* AV1 only where the device decodes it in hardware (smooth + power-efficient);
   VP9 next, H.264 last. Software AV1 is never chosen — it drains phone batteries. */
let cinFormatsPromise=null;
function cinFormats(){
 if(cinFormatsPromise)return cinFormatsPromise;
 cinFormatsPromise=(async()=>{
  const probe=document.createElement('video'),mc=navigator.mediaCapabilities,good=[],fallback=[];
  for(const key of ['av1','webm','mp4']){
   const type=CIN_TYPES[key];
   if(!probe.canPlayType(type))continue;
   let info=null;
   try{if(mc&&mc.decodingInfo)info=await mc.decodingInfo({type:'file',video:{contentType:type,width:3200,height:1680,bitrate:1500000,framerate:30}});}catch(e){}
   if(info&&!info.supported)continue;
   if(info?(info.smooth&&info.powerEfficient):key!=='av1')good.push(key);
   else if(key!=='av1')fallback.push(key);
  }
  return good.concat(fallback);
 })();
 return cinFormatsPromise;
}
function cinWhenIdle(fn){
 const go=()=>{if('requestIdleCallback' in window)window.requestIdleCallback(fn,{timeout:1500});else window.setTimeout(fn,300);};
 if(document.readyState==='complete')go();else window.addEventListener('load',go,{once:true});
}
if(!window.createOneMinersMotion){
window.createOneMinersMotion=function({root,config,models,mobile,reduce,paused=false,onPlaying=()=>{}}){
 const connection=navigator.connection,players=new Map();
 let current=0,active=null,layer=null,prefetchTimer,visible=true,optIn=false,selection=0,started=false,formats=['mp4','webm'];
 const layout=()=>mobile&&mobile.matches?'mobile':'desktop';
 // Data-saver or 2G keeps the still scene: no clip is ever requested. (3g is not skipped — Chrome reports it for many ordinary connections.)
 const slow=()=>!!(connection&&(connection.saveData||/^(slow-2g|2g)$/.test(connection.effectiveType||'')));
 const allowed=()=>started&&visible&&!document.hidden&&!slow()&&(!(reduce&&reduce.matches)||optIn);
 function sources(index){
  const entry=config[models[index].sceneKey],variant=entry&&entry[layout()];
  if(!variant)return [];
  // One format per clip, in the order the device decodes best (see cinFormats).
  return formats.filter(key=>variant[key]).map(key=>({src:variant[key],type:CIN_TYPES[key]}));
 }
 function cancelPrefetch(){window.clearTimeout(prefetchTimer);}
 function hide(player){player.playToken++;player.video.autoplay=false;player.video.pause();player.video.classList.remove('is-visible');}
 function reveal(player){
  if(player!==active||paused||!allowed()||player.video.paused||player.video.readyState<2||player.failed)return;
  player.video.classList.add('is-visible');root.dataset.motion='playing';
  if(player.presentedSelection!==selection){player.presentedSelection=selection;onPlaying(current);queueNext();}
 }
 function loadSource(player){
  player.loadToken++;player.failed=false;player.video.muted=true;player.video.defaultMuted=true;
  player.video.loop=true;player.video.src=player.items[player.sourceIndex].src;player.video.load();
 }
 function fallback(player,loadToken){
  if(player.loadToken!==loadToken||player.failed)return;
  player.playToken++;player.video.classList.remove('is-visible');
  if(++player.sourceIndex<player.items.length){loadSource(player);if(player===active)start(player);}
  else{player.failed=true;hide(player);if(player===active)root.dataset.motion='poster';}
 }
 function start(player){
  if(player!==active||player.failed||paused||!allowed())return;
  const token=++player.playToken,loadToken=player.loadToken,video=player.video;
  video.muted=true;video.defaultMuted=true;video.loop=true;video.autoplay=true;
  let promise;
  try{promise=video.play();}catch(e){fallback(player,loadToken);return;}
  if(promise&&promise.then)promise.then(()=>{
   // Cached players may resolve play() without another 'playing' event.
   if(player===active&&player.playToken===token)reveal(player);
  }).catch(error=>{
   if(player!==active||player.playToken!==token||player.loadToken!==loadToken)return;
   if(error.name==='NotSupportedError'){fallback(player,loadToken);return;}
   if(error.name==='AbortError'&&player.abortRetries++<2){
    window.setTimeout(()=>{if(player===active&&player.playToken===token)start(player);},80);return;
   }
   video.classList.remove('is-visible');root.dataset.motion='poster';
  });
 }
 function getPlayer(index){
  const items=sources(index);if(!items.length)return null;
  const key=models[index].sceneKey+':'+layout();if(players.has(key))return players.get(key);
  if(!layer){layer=document.createElement('div');layer.className='cin-video-layer';layer.setAttribute('aria-hidden','true');root.querySelector('.cin-backdrop').after(layer);}
  const video=document.createElement('video');video.className='cin-orbit';video.loop=true;video.muted=true;video.defaultMuted=true;video.playsInline=true;video.preload='auto';video.tabIndex=-1;
  video.setAttribute('muted','');video.setAttribute('playsinline','');video.setAttribute('loop','');video.setAttribute('disablepictureinpicture','');video.setAttribute('disableremoteplayback','');video.dataset.miner=models[index].sceneKey;
  const player={video,items:items.filter(item=>video.canPlayType(item.type)),sourceIndex:0,loadToken:0,playToken:0,presentedSelection:-1,failed:false,abortRetries:0};
  players.set(key,player);layer.append(video);
  video.addEventListener('playing',()=>reveal(player));
  video.addEventListener('canplay',()=>{if(player===active&&!paused)start(player);});
  video.addEventListener('loadeddata',()=>{if(player===active&&!paused)start(player);});
  video.addEventListener('error',()=>fallback(player,player.loadToken));
  if(player.items.length)loadSource(player);else player.failed=true;
  return player;
 }
 function queueNext(){
  cancelPrefetch();if(!active||paused||!allowed())return;
  prefetchTimer=window.setTimeout(()=>{if(!paused&&allowed())getPlayer((current+1)%models.length);},200);
 }
 function select(index,{restart=true}={}){
  const previous=active;current=index;cancelPrefetch();
  if(!allowed()){active=null;players.forEach(hide);root.dataset.motion='poster';return;}
  const player=getPlayer(index);players.forEach(candidate=>{if(candidate!==player)hide(candidate);});active=player;
  if(!player){root.dataset.motion='poster';return;}
  if(player.failed&&player.items.length){player.sourceIndex=0;loadSource(player);}
  if(previous!==player||restart){
   selection++;player.presentedSelection=-1;player.abortRetries=0;player.video.classList.remove('is-visible');
   try{player.video.currentTime=0;}catch(e){}
  }
  root.dataset.motion=player.video.classList.contains('is-visible')?'playing':'poster';start(player);
 }
 function setPaused(value){
  paused=value;cancelPrefetch();
  if(paused){players.forEach(player=>{player.playToken++;player.video.autoplay=false;player.video.pause();});root.dataset.motion=active&&active.video.classList.contains('is-visible')?'paused':'poster';}
  else{optIn=true;if(!active)select(current);else{start(active);queueNext();}}
 }
 function resumeVisible(){if(allowed()&&!paused){if(active)start(active);else select(current);}}
 function pauseAll(){cancelPrefetch();players.forEach(player=>{player.playToken++;player.video.pause();});}
 document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseAll();else resumeVisible();});
 if(typeof IntersectionObserver==='function')new IntersectionObserver(entries=>{
  visible=entries[0].isIntersecting;
  if(!visible)pauseAll();else resumeVisible();
 },{threshold:0.05}).observe(root);
 if(mobile&&mobile.addEventListener)mobile.addEventListener('change',()=>{
  players.forEach(player=>{hide(player);player.video.removeAttribute('src');player.video.load();player.video.remove();});players.clear();active=null;select(current);
 });
 if(reduce&&reduce.addEventListener)reduce.addEventListener('change',event=>{if(event.matches){optIn=false;select(current);}});
 if(connection&&connection.addEventListener)connection.addEventListener('change',()=>select(current));
 function playbackStats(){
  if(!active)return {status:'poster',totalFrames:null,droppedFrames:null};
  const video=active.video;
  const quality=typeof video.getVideoPlaybackQuality==='function'?video.getVideoPlaybackQuality():null;
  const total=quality?quality.totalVideoFrames:typeof video.webkitDecodedFrameCount==='number'?video.webkitDecodedFrameCount:null;
  const dropped=quality?quality.droppedVideoFrames:typeof video.webkitDroppedFrameCount==='number'?video.webkitDroppedFrameCount:null;
  return {miner:models[current].sceneKey,status:video.paused?'paused':'playing',format:active.items[active.sourceIndex]&&active.items[active.sourceIndex].type,
   width:video.videoWidth,height:video.videoHeight,currentTime:video.currentTime,totalFrames:total,droppedFrames:dropped,
   droppedPercent:total&&dropped!==null?Math.round(dropped/total*10000)/100:total===0?0:null};
 }
 // Called once the page has loaded and the browser is idle, with the device's format order.
 function begin(order){if(order&&order.length)formats=order;started=true;select(current);}
 return {select,setPaused,playbackStats,begin};
};
}

function initCinematic(root){
 if(!root||root.dataset.cinReady)return;
 root.dataset.cinReady='1';
 const read=sel=>{const el=root.querySelector(sel);try{return el?JSON.parse(el.textContent):null;}catch(e){return null;}};
 const models=read('[data-cin-products]')||[];
 const scenes=read('[data-cin-scenes]')||{};
 const videos=read('[data-cin-videos]')||{};
 const S=read('[data-cin-strings]')||{};
 if(!models.length)return;
 const fill=(tpl,vars)=>String(tpl||'').replace(/\{(\w+)\}/g,(m,k)=>vars[k]!==undefined?vars[k]:m);
 const tabs=Array.from(root.querySelectorAll('[role="tab"]'));
 const stage=root.querySelector('[data-stage]');
 const photo=root.querySelector('[data-scene-photo]');
 const mobilePhoto=root.querySelector('[data-scene-mobile]');
 const panel=root.querySelector('[role="tabpanel"]');
 const name=root.querySelector('[data-name]');
 const specs=root.querySelector('[data-specs]');
 const pricePrefix=root.querySelector('[data-price-prefix]');
 const price=root.querySelector('[data-price]');
 const priceWrap=root.querySelector('[data-price-wrap]');
 const earnings=root.querySelector('[data-earnings]');
 const earningsWrap=root.querySelector('[data-earnings-wrap]');
 const host=root.querySelector('[data-host]');
 const status=root.querySelector('[role="status"]');
 const tablist=root.querySelector('[role="tablist"]');
 const tourToggle=root.querySelector('[data-tour-toggle]');
 const reduce=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
 const mobile=window.matchMedia?window.matchMedia('(max-width: 1000px)'):null;
 // Milliseconds: normal dwell, then the longer delay after manual interaction.
 const TOUR_INTERVAL=(parseFloat(root.dataset.tourSeconds)||4)*1000,MANUAL_DELAY=TOUR_INTERVAL*2;
 const holds=new Set();
 let current=parseInt(root.dataset.selected,10)||0,timer,tourTimer,gesture,keyboardInput=false,nextTourDelay=TOUR_INTERVAL;
 let userPaused=!!(reduce&&reduce.matches),pinned=false;
 const motion=window.createOneMinersMotion({root,config:videos,models,mobile,reduce,paused:userPaused,onPlaying:()=>scheduleTour()});
 // Read-only, on-demand native browser counters; no timer or extra UI work.
 window.oneMinersPlaybackStats=motion.playbackStats;
 function stopTour(){window.clearTimeout(tourTimer);}
 function scheduleTour(delay=nextTourDelay){
  nextTourDelay=delay;stopTour();
  if(userPaused||holds.size||document.hidden||models.length<2)return;
  tourTimer=window.setTimeout(()=>{
   select((current+1)%models.length,{announce:false,automatic:true});
   scheduleTour(TOUR_INTERVAL);
  },delay);
 }
 function hold(reason){holds.add(reason);stopTour();}
 function release(reason){if(holds.delete(reason))scheduleTour(MANUAL_DELAY);}
 function updateTourControl(){
  const label=pinned?S.resume:userPaused?S.play:S.pause;
  tourToggle.dataset.paused=String(userPaused||pinned);
  tourToggle.setAttribute('aria-label',label||'');tourToggle.title=label||'';
 }
 function manualSelect(index,options){select(index,options);scheduleTour(MANUAL_DELAY);}
 function pinCurrent(){
  pinned=true;userPaused=false;root.dataset.pinned='true';hold('pinned');
  motion.setPaused(false);updateTourControl();
  status.textContent=fill(S.held,{name:models[current].name});
 }
 panel.addEventListener('click',event=>{if(!event.target.closest('a,button'))pinCurrent();});
 panel.addEventListener('keydown',event=>{
  if(event.target===panel&&(event.key==='Enter'||event.key===' ')){event.preventDefault();pinCurrent();}
 });
 function select(index,{focus=false,announce=true,automatic=false,initial=false}={}){
  if(!Number.isInteger(index)||index<0||index>=models.length)return;
  const changed=current!==index||initial;
  current=index;
  const model=models[index];
  const scene=scenes[model.sceneKey]||{};
  root.dataset.selected=String(index);
  stage.setAttribute('aria-label',model.name+(model.hashrate?' — '+model.hashrate:''));
  if(mobilePhoto&&scene.mobileSrc)mobilePhoto.srcset=scene.mobileSrc;
  if(photo&&scene.src&&photo.getAttribute('src')!==scene.src)photo.src=scene.src;
  motion.select(index,{restart:changed});
  name.textContent=model.name;
  specs.textContent=model.specs;
  pricePrefix.textContent=model.priceVaries?S.from:'';
  price.textContent=model.price;
  if(priceWrap)priceWrap.hidden=!model.price;
  if(earnings)earnings.textContent=model.earnings;
  if(earningsWrap)earningsWrap.hidden=!model.earnings;
  host.href=model.url;
  host.setAttribute('aria-label',fill(S.hostAria,{name:model.name}));
  tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(index===i));tab.tabIndex=index===i?0:-1;});
  if(tabs[index])panel.setAttribute('aria-labelledby',tabs[index].id);
  if(announce&&changed&&!initial)status.textContent=fill(S.changed,{name:model.name,specs:model.specs,price:(model.priceVaries?S.from:'')+model.price,earnings:model.earnings});
  if(changed&&!initial&&!(reduce&&reduce.matches)){
   window.clearTimeout(timer);panel.classList.remove('is-changing');void panel.offsetWidth;
   panel.classList.add('is-changing');timer=window.setTimeout(()=>panel.classList.remove('is-changing'),250);
  }
  if(focus&&tabs[index])tabs[index].focus({preventScroll:true});
  if(mobile&&mobile.matches&&tabs[index]&&!initial){
   const tab=tabs[index];
   if(tablist.scrollTo)tablist.scrollTo({left:tab.offsetLeft-(tablist.clientWidth-tab.offsetWidth)/2,behavior:reduce&&reduce.matches?'auto':'smooth'});
  }
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('pointerenter',event=>{
   if(event.pointerType!=='mouse'&&event.pointerType!=='pen')return;
   hold('pointer-tabs');manualSelect(index);
  });
  tab.addEventListener('click',()=>manualSelect(index));
  tab.addEventListener('keydown',event=>{
   let next;
   if(event.key==='ArrowRight')next=(index+1)%models.length;
   else if(event.key==='ArrowLeft')next=(index+models.length-1)%models.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=models.length-1;
   else return;
   event.preventDefault();manualSelect(next,{focus:true});
  });
 });
 // Hold the chosen product while reading its details or using its purchase link.
 for(const element of [tablist,panel,tourToggle]){
  element.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'||event.pointerType==='pen')hold(element);});
  element.addEventListener('pointerleave',()=>{release(element);if(element===tablist)release('pointer-tabs');});
 }
 document.addEventListener('keydown',()=>{keyboardInput=true;},true);
 document.addEventListener('pointerdown',()=>{keyboardInput=false;release('keyboard');},true);
 root.addEventListener('focusin',event=>{if(keyboardInput&&event.target!==tourToggle)hold('keyboard');});
 root.addEventListener('focusout',event=>{if(!root.contains(event.relatedTarget)||event.relatedTarget===tourToggle)release('keyboard');});
 tourToggle.addEventListener('click',()=>{
  if(pinned){
   pinned=false;root.dataset.pinned='false';holds.delete('pinned');holds.delete(tourToggle);
   userPaused=false;motion.setPaused(false);updateTourControl();scheduleTour(TOUR_INTERVAL);return;
  }
  userPaused=!userPaused;updateTourControl();
  motion.setPaused(userPaused);
  // Explicit Play starts a fresh full dwell, even while its control is hovered.
  if(!userPaused)holds.delete(tourToggle);
  scheduleTour(TOUR_INTERVAL);
 });
 stage.addEventListener('pointerdown',event=>{
  if(event.isPrimary===false)return;
  gesture={x:event.clientX,y:event.clientY};hold('gesture');
  if(stage.setPointerCapture)stage.setPointerCapture(event.pointerId);
 });
 stage.addEventListener('pointerup',event=>{
  if(!gesture)return;
  const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;gesture=null;
  if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4)manualSelect((current+(dx<0?1:models.length-1))%models.length);
  release('gesture');
 });
 stage.addEventListener('pointercancel',()=>{gesture=null;release('gesture');});
 stage.addEventListener('lostpointercapture',()=>{gesture=null;release('gesture');});
 // Leaving the page never accumulates missed steps or causes a rapid catch-up.
 document.addEventListener('visibilitychange',()=>{if(document.hidden)stopTour();else scheduleTour(TOUR_INTERVAL);});
 if(reduce&&reduce.addEventListener)reduce.addEventListener('change',event=>{
  if(event.matches){userPaused=true;updateTourControl();motion.setPaused(true);stopTour();}
 });
 select(current,{announce:false,initial:true});updateTourControl();scheduleTour();
 // The still scene is the first paint (LCP); clips only start after the page has loaded.
 cinWhenIdle(()=>cinFormats().then(order=>motion.begin(order)));
}

document.querySelectorAll('[data-cinematic]').forEach(initCinematic);
document.addEventListener('shopify:section:load',event=>{
 const root=event.target&&event.target.querySelector?event.target.querySelector('[data-cinematic]'):null;
 if(root)initCinematic(root);
});
})();
